import { connect } from 'react-redux';

import GameOverBlock from './GameOverBlock';
import { restartGame } from '../../redux/actions/creators/app-state';

const mapStateToProps = ({ appState: { score } }) => ({
  score,
});

const actionCreators = {
  restartGame,
};

export default connect(mapStateToProps, actionCreators)(GameOverBlock);
